import type { ThemeOptions } from '@mui/material/styles';

const typography: ThemeOptions['typography'] = {
  fontFamily: ['Source Sans Pro', 'Bitter', 'sans-serif'].join(','),
  h1: {
    fontFamily: 'Bitter',
    fontSize: '36px',
    fontWeight: '700',
    lineHeight: '48px',
    letterSpacing: '0.5px',
  },
  h2: {
    fontFamily: 'Bitter',
    fontSize: '30px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '40px',
    letterSpacing: '0.25px',
  },
  h3: {
    fontFamily: 'Bitter',
    fontSize: '21px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '32px',
  },
  h5: {
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '24px',
  },
  h6: {
    fontFamily: 'Source Sans Pro',
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '18px',
    letterSpacing: '0.16px',
  },
  body1: {
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  body2: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '143%',
    letterSpacing: '0.17px',
  },
  subtitle1: {
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '175%',
    letterSpacing: '0.15px',
  },
  subtitle2: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '157%',
    letterSpacing: '0.1px',
  },
  overline: {
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '266%',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
};

export { typography };
